import IconExpired from '@/assets/svg/expired.svg?react';
import { useClientI18nModelStore } from '@/models/client-i18n/clientI18n';
import clsx from 'clsx';

export const IpError = () => {
  const clientI18n = useClientI18nModelStore((x) => x.clientI18n);
  return (
    <div
      className={clsx('flex w-auto flex-col items-center justify-center max-os:p-5 os:w-[480px]')}
    >
      <IconExpired />

      <div className="align-center mt-8 flex justify-center text-center text-2xl font-semibold text-color">
        {clientI18n('onlineShare.noAccess')}
      </div>

      <div className="align-center mt-2 text-center text-lg font-400 text-secondary">
        {clientI18n('onlineShare.expired.subTitle')}
      </div>
    </div>
  );
};
